export default "/dist/files/icon_hotel.ab55904b93af9f020ed6022d1ab1c149.svg";